<template>
  <van-popup v-bind="$attrs" v-on="$listeners" position="right"
             style="width: 90%; height: 100%;"
             safe-area-inset-bottom>
    <van-sticky>
      <van-search v-model="filter.searchText" placeholder="商品名称、编号" @search="onSearch">
        <template #left><span style="margin-right: 10px; color: deepskyblue; font-weight: 500">商品选择</span>
        </template>
      </van-search>
      <div style="border-top: solid 1px lightgray; height: 0"></div>
      <div class="filterDiv" style="display: flex; align-items: center">
        <label style="margin-right: 10px">供应商</label>
        <remote-van-select title="供应商" class-name="SUPPLIER" v-model="filter.supplierCode" using-code select-all>
        </remote-van-select>
      </div>
      <div style="border-top: solid 1px gray; height: 0px"></div>
    </van-sticky>
    <div :style="{'height': listHeight + 'px'}" style="background-color: darkgray; overflow: scroll">
      <transition-group name="list-complete">
        <div v-for="(item, index) of goodsList" :key="item.id"
             style="background-color: white; margin: 0 4px 8px 4px; padding: 6px; overflow: hidden;"
             class="list-complete-item">
          <div>
            <div style="height: 26px; line-height: 28px;" :style="{'margin-top': index > 0 ? '6px' : 0}">
              <label class="label">序号</label>
              <span class="value">
              <span style="width: 30px; display: inline-block">{{ index }}</span>
              <el-checkbox v-model="item.selected"></el-checkbox>
            </span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品编号</label>
              <span class="value">{{ item.code }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品名称</label>
              <span class="value">{{ item.name }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">商品类型</label>
              <span class="value">{{ item.typeCode | valueName('GOODS_TYPE') }}</span>
            </div>
            <div style="height: 26px; line-height: 28px;">
              <label class="label">单位</label>
              <span class="value">{{ item.unit }}</span>
            </div>
            <div v-if="item.selected" style="height: 26px; line-height: 28px;">
              <label class="label">生产日期</label>
              <wx-date-select class="value date" v-model="item.productionDate"
                              style="position: relative; top: -4px"></wx-date-select>
            </div>
            <div v-if="item.selected" style="height: 26px; line-height: 28px;">
              <label class="label">保质期</label>
              <el-input class="value" style="width: 60px" v-model.number="item.expireDays" size="mini"></el-input>
            </div>
            <div v-if="item.selected" style="height: 26px; line-height: 28px;">
              <label class="label">数量</label>
              <el-input class="value" style="width: 60px" v-model.number="item.num" size="mini"></el-input>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <div style="display: flex; justify-content: center; background-color: white; padding: 20px">
      <van-button type="primary" style="margin-right: 20px; width: 160px" @click="confirm">确 定</van-button>
      <van-button style="width: 160px" @click="cancel">取 消</van-button>
    </div>
  </van-popup>
</template>

<script>
import { Button, Popup, Search, Sticky, Tag, Field, DatetimePicker, Toast, Picker } from 'vant'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import RemoteVanSelect from '@/components/selector/RemoteVanSelect'
import WxDateSelect from '@/views/wx/product/WxDateSelect'

export default {
  name: 'WxSelectGoods',
  mixins: [resizeCaptureMixin],
  components: {
    WxDateSelect,
    RemoteVanSelect,
    [Search.name]: Search,
    [Sticky.name]: Sticky,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Field.name]: Field,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker
  },
  props: {
    inbound: {
      type: Object,
      required: true
    },
    readOnly: Boolean
  },
  data () {
    return {
      goodsList: [],
      filter: {
        searchText: null,
        showSupplier: false,
        supplierCode: null
      }
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'SUPPLIER')
    this.$store.dispatch('goods/all').finally(() => {
    })
  },
  methods: {
    onSearch () {
    },
    confirm () {
      for (const item of this.goodsList) {
        if (!item.selected) continue
        if (item.num === 0) {
          Toast.fail(`请填写 ${item.name} 的数量`)
          return
        }
        if (!item.productionDate) {
          Toast.fail(`请填写 ${item.name} 的生产日期`)
          return
        }
        if (typeof item.productionDate === 'object') {
          item.productionDate = item.productionDate.format('yyyy-MM-dd')
        }
        if (!item.expireDays) {
          Toast.fail(`请填写 ${item.name} 的有效日期天数`)
          return
        }
      }
      this.$emit('update', this.goodsList.filter(item => item.selected))
      this.hide()
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('input', false)
    }
  },
  computed: {
    listHeight () {
      return this.clientHeight - 110 - 60 - 20
    },
    change () {
      return {
        inbound: this.inbound,
        supplierCode: this.filter.supplierCode,
        searchText: this.filter.searchText
      }
    }
  },
  watch: {
    change () {
      const goodsIdMap = {}
      for (const goods of this.inbound.goodsList) {
        goodsIdMap[goods.id] = goods
      }
      let list = this.$_.cloneDeep(this.$store.state.goods.goodsList)
      for (const goods of list) {
        const selectedGoods = goodsIdMap[goods.id]
        if (selectedGoods) {
          this.$set(goods, 'selected', true)
          this.$set(goods, 'num', selectedGoods.num)
          this.$set(goods, 'productionDate', selectedGoods.productionDate)
          this.$set(goods, 'expireDays', selectedGoods.expireDays)
        } else {
          this.$set(goods, 'selected', false)
          this.$set(goods, 'num', 0)
          this.$set(goods, 'productionDate', new Date().format('yyyy-MM-dd'))
          this.$set(goods, 'expireDays', 0)
        }
      }

      if (this.filter.searchText) {
        list = list.filter(item =>
          item.name.indexOf(this.filter.searchText) >= 0 ||
          item.code.indexOf(this.filter.searchText) >= 0
        )
      }

      if (this.filter.supplierCode && this.filter.supplierCode !== -1) {
        list = list.filter(item => item.supplierCode === this.filter.supplierCode)
      }

      this.goodsList = list
    }
  }
}
</script>

<style lang="scss" scoped>
.filterDiv {
  margin: 16px 12px;
  font-size: 16px;
  height: 22px;
  line-height: 22px;
  display: flex
}

label {
  color: #606266;
  font-size: 14px;
}

.label {
  display: inline-block;
  width: 100px;
  color: #646464;
  font-size: 14px;
  text-align: right;
  height: 28px;
  line-height: 28px;
}

.value {
  display: inline-block;
  color: black;
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  margin-left: 20px;
}

/deep/
.el-input--mini .el-input__inner {
  height: 20px;
  line-height: 20px;
}

.date {
  /deep/
  .van-button--small {
    height: 24px;
  }
}
</style>
